import * as React from "react";

import styled from "styled-components";
import { getDonateRecordsByGroupId, setDonateFinishedById } from "../api/api";
import { Breadcrumb, Button, Table, message } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AnyType } from "../util/types";
import DonateAddModal from "../comp/donateAddModal";
import moment from "moment";

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    .list {
      /* flex: 1; */
    }
    .item {
      height: 50px;
      border-bottom: 1px dashed gray;
      font-size: 14px;
      line-height: 50px;
      cursor: pointer;
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
`;

const DonateDetail: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [querys] = useSearchParams();
  const id = querys.getAll("id")[0] || "";

  const [alist, setalist] = React.useState<Array<any>>([]);
  const [modalVisible, setModalVisible] = React.useState(false);

  const [amounts, setAmounts] = React.useState<AnyType>({});

  const agetList = async () => {
    const ret = await getDonateRecordsByGroupId(id);

    const idAndUserMap = ret?.idAndUserMap || ([] as Array<any>);
    const donateRecords = ret?.donateRecords || ([] as Array<any>);

    const donates = donateRecords.map((x: AnyType) => ({
      ...x,
      nickName: idAndUserMap[x.userId].nickName,
    }));

    setalist(donates);

    const { costAmount, totleAmount } = ret;
    setAmounts({ costAmount, totleAmount });
  };

  React.useEffect(() => {
    agetList();
  }, []);

  const goConfirm = async (x: any) => {
    const ret = await setDonateFinishedById(x.id);
    message.success("乐捐成功");
    agetList();
  };

  const colums = [
    { title: "用户", dataIndex: "nickName", width: "15%" },
    {
      title: "时间",
      dataIndex: "nickName",
      width: "15%",
      render: (_: string, record: any) =>
        moment(record.createAt).format("YYYY年MM月DD日"),
    },
    { title: "类型", dataIndex: "donateTypeStr", width: "15%" },
    {
      title: "金额",
      dataIndex: "amount",
      width: "15%",
      render: (_: string, record: any) =>
        record.donateType > 100 ? (
          <span style={{ color: "red" }}> {`-${record.amount}`}</span>
        ) : (
          <span> {`${record.amount}`}</span>
        ),
    },
    {
      title: "支付情况",
      dataIndex: "x",
      render: (_: string, record: any) =>
        record.state === 10 ? (
          <Button disabled className="w120" size="small">
            已完成
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => goConfirm(record)}
            className="w120"
            size="small"
          >
            确认已支付
          </Button>
        ),
    },
    { title: "备注", dataIndex: "description", width: "18%" },
  ];

  const modalFinishHandler = (b: boolean) => {
    setModalVisible(false);
    if (b) {
      agetList();
    }
  };

  return (
    <Container>
      <DonateAddModal
        open={modalVisible}
        onFinish={modalFinishHandler}
        gid={id}
      />
      <div className="content">
        <div className="breadCrmb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <span className="p" onClick={() => navigate("/group")}>
                首页
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>小组乐捐情况</Breadcrumb.Item>
          </Breadcrumb>
          <div style={{ fontSize: 14, fontWeight: 700 }}>
            <span style={{ marginRight: 20 }}>
              乐捐总额: {amounts.totleAmount}
            </span>
            <span style={{ marginRight: 20, fontSize: 14 }}>
              花费总额:
              {amounts.costAmount}
            </span>
            <span style={{ marginRight: 20, fontSize: 14 }}>
              余额:
              {amounts.totleAmount - amounts.costAmount}
            </span>
            <Button type="primary" onClick={() => setModalVisible(true)}>
              录入
            </Button>
          </div>
        </div>
        <Table
          dataSource={alist}
          columns={colums}
          rowKey={(x) => `${x.id}`}
          pagination={false}
          bordered
          size="small"
        />
      </div>
    </Container>
  );
};

export default DonateDetail;
